export const promoteAssignedKegsMutation = /* GraphQL */ `mutation PromoteAssignedKegs($input: inputPromoteAssignedKegs!) {
	promoteAssignedKegs(input: $input){
        id  
    }}`
